"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = require("classnames");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var store_1 = require("./store");
var ScrollLoad_1 = require("mobile/components/ScrollLoad");
var ProductsTag_1 = require("./ProductsTag");
var mobx_1 = require("mobx");
var ViewMoreCard_1 = require("./ViewMoreCard");
var tool_1 = require("mobile/utils/tool");
var SmallLoading_1 = require("mobile/ezUI/SmallLoading");
var common_1 = require("services/page/common");
var jsBridge_1 = require("../../../utils/jsBridge");
var LTProductsCard_1 = require("./LTProductsCard");
var WithPrm_1 = require("components/WithPrm");
var styles = require("./index.scss");
var MProducts = (function (_super) {
    __extends(MProducts, _super);
    function MProducts(props) {
        var _this = _super.call(this, props) || this;
        _this.onLoadMoreProducts = function (poolId) { return function () { return __awaiter(_this, void 0, void 0, function () {
            var products;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.MProductsStore.loadProductsList(poolId, (this.MProductsStore.productsPage[poolId] || 1) + 1)];
                    case 1:
                        _a.sent();
                        products = mobx_1.toJS(this.MProductsStore.productsListMap) &&
                            mobx_1.toJS(this.MProductsStore.productsListMap)[poolId];
                        return [2, { loadCount: products.length, isError: false }];
                }
            });
        }); }; };
        _this.onTouchMove = function (poolId) { return function (e) {
            var startPoint = _this.state.dragPoints.startPoint;
            var div = _this.touchDiv.children[0];
            var productsNum = div.children.length;
            var parentScrollLeft = div.scrollLeft;
            var middleProductLeft = div.children[productsNum - 1].offsetLeft / 2;
            if (parentScrollLeft >= middleProductLeft) {
                _this.MProductsStore.loadProductsList(poolId, (_this.MProductsStore.productsPage[poolId] || 1) + 1);
            }
            if (_this.isDragging) {
                var touch = e.touches[0];
                var endPoint = {
                    x: touch.clientX,
                    y: touch.clientY
                };
                var a = Math.abs(endPoint.x - startPoint.x);
                var b = Math.abs(endPoint.y - startPoint.y);
                if (endPoint.y - startPoint.y > 0 && Math.abs((Math.atan2(b, a) * 180) / Math.PI) >= 60) {
                    jsBridge_1.enableRefresh({ refresh: true });
                }
            }
        }; };
        _this.onTouchStart = function (e) {
            var touch = e.touches[0];
            var dragPoints = {
                startPoint: {
                    x: touch.clientX,
                    y: touch.clientY
                }
            };
            _this.setState({ dragPoints: dragPoints });
            jsBridge_1.enableRefresh({ refresh: false });
        };
        _this.onTouchEnd = function () {
            jsBridge_1.enableRefresh({ refresh: true });
        };
        _this.onTagsChange = function (category, activeTab) {
            var _a = _this.MProductsStore, loadProductsList = _a.loadProductsList, productsListMap = _a.productsListMap;
            if (category.poolId && !productsListMap[category.poolId]) {
                loadProductsList(category.poolId, 0);
            }
            _this.setState({ activeTab: activeTab });
        };
        _this.renderMProductsList = function (poolId) {
            var _a = _this.props, moduleDetail = _a.moduleDetail, index = _a.index;
            var products = mobx_1.toJS(_this.MProductsStore.productsListMap) &&
                mobx_1.toJS(_this.MProductsStore.productsListMap)[poolId];
            var layout, ui;
            if (moduleDetail) {
                layout = moduleDetail.layout;
                ui = moduleDetail.ui;
            }
            if (!products) {
                return null;
            }
            return (React.createElement(React.Fragment, null,
                products.map(function (item, i) {
                    return (React.createElement(LTProductsCard_1.default, { productElement: item, key: index + "_" + i, layout: layout, ui: ui, index: i, tprm: _this.props.tprm }));
                }),
                React.createElement(React.Fragment, null, mobx_1.toJS(_this.MProductsStore.viewMoreLink[poolId]) && (React.createElement(ViewMoreCard_1.default, { isRollOver: layout.interaction === common_1.ModuleInteraction.RollOver, key: "" + mobx_1.toJS(_this.MProductsStore.viewMoreLink[poolId]), link: mobx_1.toJS(_this.MProductsStore.viewMoreLink[poolId]), params: _this.props.tprm })))));
            return null;
        };
        _this.state = {
            activeTab: 0,
            dragPoints: null
        };
        _this.MProductsStore = new store_1.default(props.proModules);
        return _this;
    }
    MProducts.prototype.componentDidMount = function () {
        var activeTab = tool_1.heightLightTabIndex(this.props.proModules);
        if (activeTab > 0) {
            this.setState({ activeTab: activeTab });
        }
        var loadProductsList = this.MProductsStore.loadProductsList;
        var currentPool = this.props.proModules[Math.max(0, activeTab)];
        currentPool && loadProductsList(currentPool.poolId);
    };
    MProducts.prototype.isDragging = function () {
        return this.state.dragPoints !== null;
    };
    MProducts.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var _c = this.props, proModules = _c.proModules, commonProps = _c.commonProps, index = _c.index, setTopMap = _c.setTopMap, addModuleMap = _c.addModuleMap, moduleDetail = _c.moduleDetail, navFixed = _c.navFixed, hasTitle = _c.hasTitle, moduleMap = _c.moduleMap, topMap = _c.topMap;
        var currentPool = proModules[this.state.activeTab];
        var poolId = currentPool && currentPool.poolId;
        var loading = poolId ? this.MProductsStore.isLoadingProducts[poolId] : false;
        return (React.createElement("div", { ref: function (node) {
                if (node) {
                    setTopMap(index, node);
                    addModuleMap(index, node, "#" + commonProps.id);
                }
            } },
            React.createElement("div", { className: classnames_1.default(styles.outsideContainer) },
                proModules.length > 1 && (React.createElement(ProductsTag_1.default, { proModules: proModules, navFixed: navFixed, ui: moduleDetail.ui, hasTitle: hasTitle, index: index, moduleMap: moduleMap, changeActiveTab: this.onTagsChange, activeTab: this.state.activeTab, topMap: topMap, moduleDetail: moduleDetail })),
                moduleDetail.layout.interaction === common_1.ModuleInteraction.RollOver ? (React.createElement("div", { className: classnames_1.default(styles.insideContainer, styles.doubleCardContainer), ref: function (e) { return (_this.touchDiv = e); }, onTouchMove: this.onTouchMove(poolId), onTouchStart: this.onTouchStart, onTouchEnd: this.onTouchEnd },
                    React.createElement("div", { className: classnames_1.default(styles.rollOverContainer), style: { height: "auto" } }, this.renderMProductsList(poolId)))) : (React.createElement("div", { className: classnames_1.default(styles.insideContainer, (_a = {},
                        _a[styles.LTInsideContainer] = true,
                        _a)) },
                    React.createElement(ScrollLoad_1.default, { className: classnames_1.default((_b = {},
                            _b[styles.doubleCardContainer] = moduleDetail.layout.columnNum === 2,
                            _b[styles.tripleCardContainer] = moduleDetail.layout.columnNum === 3,
                            _b[styles.LTDoubleCardContainer] = moduleDetail.layout.columnNum === 2,
                            _b)), limit: this.MProductsStore.productLoadLimit, loadFunction: this.onLoadMoreProducts(poolId), loadDataWhenDidMount: false },
                        this.renderMProductsList(poolId),
                        loading && React.createElement(SmallLoading_1.default, null)))))));
    };
    MProducts = __decorate([
        mobx_react_1.observer
    ], MProducts);
    return MProducts;
}(React.Component));
exports.default = WithPrm_1.default(MProducts);
